// Copyright (c) 2017, Shellyl_N and Authors
// license: ISC
// https://github.com/shellyln
/**
 * Number precision / significant figure
 */
export class NumberPrecision {
    static decimalPlaces(n) {
        return (v) => {
            return Number(v.toFixed(n));
        };
    }
    static precision(n) {
        return (v) => {
            return Number(v.toPrecision(n));
        };
    }
}
//# sourceMappingURL=NumberPrecision.js.map